module.exports = __webpack_public_path__ + "static/img/cover.c3e62f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/cover.jpg
// module id = s4Ux
// module chunks = 3